import { useEffect, useRef, useState } from "react";

export function InfoRow({ label, value }: { label: string; value: string }) {
  const valueRef = useRef<HTMLSpanElement>(null);
  const [clipped, setClipped] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const element = valueRef.current;
    if (element === null) {
      return;
    }
    const measure = () => {
      if (open) {
        return;
      }
      setClipped(element.scrollWidth > element.clientWidth);
    };
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [value, open]);

  return (
    <div className="flex min-h-[24.5px] items-center justify-between gap-4">
      <span className="text-18 text-field-label shrink-0 leading-none font-medium">
        {label} :
      </span>
      <span
        ref={valueRef}
        data-selectable="true"
        title={clipped ? value : undefined}
        role={clipped ? "button" : undefined}
        tabIndex={clipped ? 0 : undefined}
        aria-expanded={clipped ? open : undefined}
        onClick={
          clipped
            ? () => {
                setOpen((previous) => !previous);
              }
            : undefined
        }
        onKeyDown={
          clipped
            ? (event) => {
                if (event.key !== "Enter" && event.key !== " ") {
                  return;
                }
                event.preventDefault();
                setOpen((previous) => !previous);
              }
            : undefined
        }
        className={`text-18 text-field-value min-w-0 flex-1 text-right font-medium ${
          open ? "leading-6 wrap-anywhere" : "truncate leading-none"
        }`}
      >
        {value}
      </span>
    </div>
  );
}
